import { useEffect } from 'react'
import type { StoryFeedItem, StorySlide } from '@entities/stories'

/** Сколько кадров вперёд греем: дальше — лишний трафик на мобильном. */
const AHEAD = 2

// Один раз на вкладку: повторный запрос того же адреса ничего не даёт.
const requested = new Set<string>()

const preload = (slide?: StorySlide) => {
  if (!slide || slide.media_type !== 'image') return
  const url = slide.media_url
  if (!url || requested.has(url)) return
  requested.add(url)
  const image = new Image()
  image.src = url
}

/**
 * Предзагрузка соседних кадров истории.
 *
 * Пока человек смотрит текущий слайд, следующие уже лежат в кеше браузера, и
 * переключение происходит без ожидания сети. Греем вперёд, назад (туда часто
 * возвращаются тапом) и первый кадр следующей истории — на него уходят концом
 * текущей. Видео так не прогреть: оно играется через плеер Kinescope.
 */
export const useStoryPreload = (
  stories: StoryFeedItem[],
  storyIndex: number,
  slideIndex: number
) => {
  useEffect(() => {
    const slides = stories[storyIndex]?.slides ?? []

    for (let step = 1; step <= AHEAD; step += 1) preload(slides[slideIndex + step])
    preload(slides[slideIndex - 1])
    preload(stories[storyIndex + 1]?.slides?.[0])
  }, [stories, storyIndex, slideIndex])
}
